import messages from './myDataDeletion.json' with { type: 'json' };

export const myDataDeletionFi: Readonly<typeof messages> = messages;
